// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"8be6b8a5","213":"706b042e","238":"fe6464b5","239":"a01dfac2","557":"116a15fa","732":"39799e24","762":"2f06b040"}[chunkId] + ".chunk.js";
};